import Vue from "vue";
import Vuex from "vuex";
import API from "../utils/api";
import { filterSensorsByState, filterSensorsByType } from "../sheriffUtils";
Vue.use(Vuex);

let store = new Vuex.Store({
  state: {
    sheriffs: null,
    sheriff: null,
    sheriffSelecionado: null,
    showDisabled: false,
    tries: 0
  },
  mutations: {
    atualizarSheriffs(state, respSheriff) {
      state.sheriffs = respSheriff;
      if (state.sheriffSelecionado)
        state.sheriff = respSheriff[state.sheriffSelecionado];
    },
    selecionarSheriff(state, sheriffSelecionado) {
      state.sheriffSelecionado = sheriffSelecionado;
      if (sheriffSelecionado == -1) {
        state.sheriff = null;
      } else {
        state.sheriff = state.sheriffs[sheriffSelecionado];
      }
    },
    toggleShowDisabled(state) {
      state.showDisabled = !state.showDisabled;
    },
    incrementarTentativas(state) {
      state.tries++;
    },
    zerarTentativas(state) {
      state.tries = 0;
    }
  },
  actions: {
    iniciarAtualizacao() {
      updater.tryInit();
    },
    selecionarSheriff(ctx, sheriff) {
      ctx.commit("selecionarSheriff", sheriff);
    },
    destroy() {
      updater.destroy();
    },
    atualizarSheriffs(ctx, respSheriff) {
      ctx.commit("atualizarSheriffs", respSheriff);
      ctx.commit("zerarTentativas");
    }
  },
  getters: {
    sensorsTemp(state) {
      return filterSensorsByType(
        state.sheriff,
        "TemperatureSensor",
        state.showDisabled
      );
    },
    sensorsMisalignment(state) {
      return filterSensorsByType(
        state.sheriff,
        "MisalignmentSensor",
        state.showDisabled
      );
    },
    sensorsMovement(state) {
      return filterSensorsByType(
        state.sheriff,
        "MovementSensor",
        state.showDisabled
      );
    },
    sensorsObstruction(state) {
      return filterSensorsByType(
        state.sheriff,
        "ObstructionSensor",
        state.showDisabled
      );
    },
    sensorsError(state) {
      return filterSensorsByState(state.sheriff, "ERROR");
    },
    sensorsTriggered(state) {
      return filterSensorsByState(state.sheriff, "TRIGGERED");
    },
    isConnected(state) {
      return state.tries <= 5;
    },
    getTentativas(state) {
      return state.tries;
    }
  }
});
let updater = (function(store) {
  let timeout;
  let $api = new API();
  function update() {
    $api
      .getSheriffs()
      .then(resp => {
        store.dispatch("atualizarSheriffs", resp.data);
      })
      .catch(() => {
        store.commit("incrementarTentativas");
      });

    timeout = setTimeout(update, 1000);
  }
  return {
    tryInit() {
      if (!timeout) update();
    },
    destroy() {
      clearTimeout(timeout);
    }
  };
})(store);

export default store;
